/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import theme from '../stylesheets/theme';
import Layout from '../components/layout';

const VarausJaPeeruStyles = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .terms-container {
    margin: 150px auto 0;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    padding: 0 16px;
  }
`;

const VarausJaPeeru = () => (
  <Layout
    seo={{
      title: 'Discover Lapland - Varaus- ja peruutusehdot',
    }}
  >
    <ThemeProvider theme={theme}>
      <VarausJaPeeruStyles>
        <div className="terms-container">
          <h2>VARAUS- JA PERUUTUSEHDOT</h2>
          <br />
          <p>
            Näitä varaus- ja peruutusehtoja sovelletaan Discover Laplandin
            järjestämiin Hetta–Pallas-vaelluksiin ja
            Hetta–Pallas-hiihtovaelluksiin.
          </p>
          <br />
          <h3>Palveluntuottaja</h3>
          <p>
            <strong>
              Discover Lapland
              <br />
              Daily Race Oy
              <br />
              Y-tunnus 2232108-3
              <br />
              <a href="https://www.google.com/maps/search/Onnenpolku+30+B+%0D%0A99130+Sirkka?entry=gmail&amp;source=g">
                Onnenpolku 30 B
              </a>
              <br />
              <a href="https://www.google.com/maps/search/Onnenpolku+30+B+%0D%0A99130+Sirkka?entry=gmail&amp;source=g">
                99130 Sirkka
              </a>
              <br />
              Puhelin 040 772 41 24
              <br />
              Sähköposti:{' '}
              <a href="mailto:anettelatvapiikkila@gmail.com">
                anettelatvapiikkila@gmail.com
              </a>
            </strong>
          </p>
          <br />
          <h3>Varaus ja osallistumispaikan vahvistaminen</h3>
          <p>
            Ilmoittautuminen tehdään sähköpostitse kyseisen vaelluksen
            tuotesivulla annettujen ohjeiden mukaisesti.
          </p>
          <br />
          <p>
            Discover Lapland arvioi osallistujan soveltuvuuden vaellukselle
            ilmoittautumisen yhteydessä annettujen tietojen perusteella.
            Osallistumispaikka vahvistetaan sähköpostitse.
          </p>
          <br />
          <p>
            Kun osallistuja on sähköpostitse vahvistanut osallistumisensa ja
            hyväksynyt varaus- ja peruutusehdot, osallistumispaikka on sitova.
          </p>
          <br />
          <h3>Hetta–Pallas-vaellus</h3>
          <p>Vaelluksen hinta on 425 € / henkilö (sis. alv.).</p>
          <br />
          <p>
            Kun osallistumispaikka on vahvistettu, osallistuja saa laskun sekä
            vaelluksen ennakkomateriaalit laskun maksamisen jälkeen.
          </p>
          <br />
          <p>Jos osallistuja peruuttaa osallistumisensa:</p>
          <p>
            vähintään 60 vuorokautta ennen vaelluksen alkua palautetaan 230 €
            <br />
            30–59 vuorokautta ennen vaelluksen alkua palautetaan 115 €
            <br />
            29 vuorokautta tai vähemmän ennen vaelluksen alkua maksua ei
            palauteta.
          </p>
          <br />
          <p>
            Peruutus tulee tehdä kirjallisesti sähköpostitse osoitteeseen{' '}
            <a href="mailto:anettelatvapiikkila@gmail.com">
              anettelatvapiikkila@gmail.com
            </a>
            .
          </p>
          <br />
          <h3>Hetta–Pallas-hiihtovaellus</h3>
          <p>Hiihtovaelluksen hinta on 1 090 € / henkilö (sis. alv.).</p>
          <br />
          <p>
            Osallistumismaksua ei veloiteta ennakkoon. Osallistumismaksu
            laskutetaan hiihtovaelluksen aloituspäivänä.
          </p>
          <br />
          <p>
            Jos osallistuja peruuttaa osallistumisensa, veloitetaan
            peruutusmaksu seuraavasti:
          </p>
          <p>
            yli 30 vuorokautta ennen hiihtovaelluksen alkua: 250 €
            <br />
            15–30 vuorokautta ennen hiihtovaelluksen alkua: 545 €
            <br />
            7–14 vuorokautta ennen hiihtovaelluksen alkua: 817,50 €
            <br />
            alle 7 vuorokautta ennen hiihtovaelluksen alkua tai jos osallistuja
            jättää saapumatta: 1 035,50 €
          </p>
          <br />
          <p>
            Peruutus tulee tehdä kirjallisesti sähköpostitse osoitteeseen{' '}
            <a href="mailto:anettelatvapiikkila@gmail.com">
              anettelatvapiikkila@gmail.com
            </a>
            .
          </p>
          <br />
          <p>
            Peruutusmaksut perustuvat osallistujalle jo toimitettuihin
            ennakkomateriaaleihin ja palveluihin sekä hiihtovaelluksen
            valmistelusta, varauksista ja peruutuksesta aiheutuviin
            kustannuksiin.
          </p>
          <br />
          <h3>Ryhmäkoko ja Discover Laplandin tekemä peruutus</h3>
          <p>Vaellusten ryhmäkoko on 5–8 osallistujaa.</p>
          <br />
          <p>
            Jos vaellukselle ei ole ilmoittautunut vähintään viittä
            osallistujaa, Discover Laplandilla on oikeus peruuttaa vaellus.
            Mahdollisesta peruuttamisesta ilmoitetaan viimeistään 7 vuorokautta
            ennen vaelluksen alkua.
          </p>
          <br />
          <p>
            Discover Laplandilla on lisäksi oikeus peruuttaa vaellus, jos
            väistämättömät ja poikkeukselliset olosuhteet estävät sen
            toteuttamisen. Tällaisesta peruuttamisesta ilmoitetaan ilman
            aiheetonta viivytystä.
          </p>
          <br />
          <p>
            Jos Discover Lapland peruuttaa vaelluksen, osallistujan Discover
            Laplandille suorittamat maksut palautetaan.
          </p>
          <br />
          <h3>Muutokset vaelluksen toteutukseen</h3>
          <p>
            Discover Lapland voi turvallisuuden sitä edellyttäessä tehdä
            vaelluksen reittiin, aikatauluun tai toteutukseen tarpeellisia
            vähäisiä muutoksia esimerkiksi sää-, lumi- tai reittiolosuhteiden
            vuoksi.
          </p>
          <br />
          <h3>Osallistujan terveydentila ja toimintakyky</h3>
          <p>
            Osallistujan tulee ilmoittautumisen yhteydessä kertoa sellaisista
            terveydentilaan, toimintakykyyn tai aikaisempiin vammoihin
            liittyvistä seikoista, joilla voi olla merkitystä vaelluksen
            turvallisen toteuttamisen kannalta.
          </p>
          <br />
          <p>
            Jos osallistuja on epävarma terveydentilansa soveltuvuudesta
            vaellukselle, hänen tulee tarvittaessa keskustella asiasta
            terveydenhuollon ammattilaisen kanssa ennen osallistumista.
          </p>
          <br />
          <p>
            Discover Laplandilla on oikeus olla vahvistamatta
            osallistumispaikkaa, jos vaelluksen turvallista toteuttamista ei
            osallistujan antamien tietojen perusteella voida kohtuudella
            varmistaa.
          </p>
          <br />
          <h3>Vakuutukset</h3>
          <p>Discover Laplandilla on toiminnan vastuuvakuutus.</p>
          <br />
          <p>
            Osallistujalla tulee olla vaelluksen ajan voimassa oleva
            henkilökohtainen matkavakuutus, joka kattaa kyseisen
            vaellustoiminnan. Osallistuja vastaa oman vakuutusturvansa
            riittävyydestä.
          </p>
          <br />
          <h3>Sovellettava laki ja erimielisyydet</h3>
          <p>Sopimukseen sovelletaan Suomen lakia.</p>
          <br />
          <p>
            Mahdolliset erimielisyydet pyritään ensisijaisesti ratkaisemaan
            asiakkaan ja Discover Laplandin välisillä neuvotteluilla. Kuluttaja
            voi tarvittaessa saattaa asian Kuluttajariitalautakunnan
            käsiteltäväksi.
          </p>
        </div>
      </VarausJaPeeruStyles>
    </ThemeProvider>
  </Layout>
);

export default VarausJaPeeru;
